import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
  vIcon: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  color: {
    type: String,
    default: "primary",
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
    }),
    required: false,
  },
},
  setup(__props) {

const props = __props



const backgroundHandler = (hover: boolean) => {
  const isPrimaryColor = props.theme.primaryColor === THEMES.PERALTA_PRIMARY
  if (hover) {
    return `${isPrimaryColor && "#d90207"} !important`
  }
  return props.theme.primaryColor
}

const textColorHandler = () => {
  return props.theme.primaryColor !== THEMES.PERALTA_PRIMARY && props.theme.textColor
}

return { __sfc: true,props, backgroundHandler, textColorHandler, Icon }
}

})